import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import FormService from "../../core/services/FormService";

function ReviewCommentModal({ modalShow, data, callbackModal }) {
  const [show, setShow] = useState(modalShow);
	const [comment, setComment] = useState(data?.comment ?? '');
  const [validated, setValidated] = useState(false);

  const handleClose = () => {
    setShow(false);
    callbackModal(false);
  };

	const onSaveComment = () => {
		setValidated(true);

		if (!comment) return;

		FormService.saveReviewComment(data.token, data.responseId, { id: data.id, comment: comment }, data.isFormInReview)
		.then(res => {
			if (res.status !== 200) return;

			setShow(false);
			callbackModal(true);
		}).catch(err => {});
	};

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Enter your review comments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
						<textarea className='form-control'
              required
							rows="5"
							placeholder=''
							value={comment}
							onChange={(e) =>  setComment(e.target.value)} >
						</textarea>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} autoFocus>
            Close
          </Button>
          <Button variant="primary" onClick={() =>  onSaveComment()} className="sbmBtn">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ReviewCommentModal;
